// extracted by mini-css-extract-plugin
export default {"ctn":"buyCard_ctn__PZfnE","buyButton":"buyCard_buyButton__rDqSy","productImg":"buyCard_productImg__ABOse","textBox":"buyCard_textBox__G9KzK"};